export { default } from './CandidateRequirements'

export type Requirement = {
	id: number
	text: string
}
export const Requirements = [
	{ id: 0, text: 'New Graduates Welcome' },
	{ id: 1, text: '1 Year' },
	{ id: 2, text: '2 Years' },
	{ id: 3, text: '3 Years' },
	{ id: 4, text: '4 Years' },
	{ id: 5, text: '5+ Years' },
]
